export const sliderItems = [
  {
    id: 1,
    img: "https://i.ibb.co/DG69bQ4/2.png",
    // img: "https://rukminim1.flixcart.com/image/832/832/l1dwknk0/dress/e/v/m/xl-318tk9004-selvia-original-imagcyvny7a8zcus.jpeg?q=70",
    title: "SUMMER SALE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fbf0f4",
  },
  {
    id: 2,
    img: "https://rukminim1.flixcart.com/image/832/832/j8t35ow0/sweatshirt/g/v/g/xl-me-3952-b-moda-elementi-original-imaeyqpzjrgzyf9w.jpeg?q=70",
    title: "AUTUMN COLLECTION",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fffeff",
  },
  {
    id: 3,
    img: "https://rukminim1.flixcart.com/image/832/832/ktbu6q80/ethnic-set/u/t/f/xxl-316k713-29tk113-saara-original-imag6p94dz3z4gfm.jpeg?q=70",
    title: "INDIAN LOVE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    // bg: "fbf0f4",
    bg: "576874",
  },
  {
    id: 4,
    // img: "https://i.ibb.co/DG69bQ4/2.png",
    img: "https://rukminim1.flixcart.com/image/832/832/l1dwknk0/dress/e/v/m/xl-318tk9004-selvia-original-imagcyvny7a8zcus.jpeg?q=70",
    title: "SUMMER SALE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    // bg: "fbf0f4",
    bg: "aaaeb6",
  },
];

export const categories = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/5886041/pexels-photo-5886041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "SHIRT STYLE!",
    cat: "women",
  },
  {
    id: 2,
    // img: "https://images.pexels.com/photos/3951783/pexels-photo-3951783.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    // img: "https://images.pexels.com/photos/2866119/pexels-photo-2866119.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    // img: "https://images.pexels.com/photos/158648/girl-coat-old-coat-brown-coat-158648.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    img: "https://images.pexels.com/photos/2887766/pexels-photo-2887766.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "COAT LOVE",
    cat: "coat",
  },
  {
    id: 3,
    img: "https://images.pexels.com/photos/5480696/pexels-photo-5480696.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    title: "LIGHT JACKETS",
    cat: "jeans",
  },
];

export const popularProducts = [
  {
    id: 1,
    img: "https://www.pngarts.com/files/1/T-Shirt-PNG-Background-Image.png",
  },
  {
    id: 2,
    img: "https://www.pngarts.com/files/1/Summer-Clothes-For-Women-PNG-Image-Background.png",
  },
  {
    id: 3,
    img: "https://www.pngarts.com/files/1/Summer-Clothes-For-Women-PNG-High-Quality-Image.png",
  },
  {
    id: 4,
    img: "https://www.pngarts.com/files/17/Halloween-T-Shirt-PNG-Pic.png",
  },
  {
    id: 5,
    img: "https://www.pngarts.com/files/2/Pink-Jacket-For-Women-PNG-Free-Download.png",
  },
  {
    id: 6,
    img: "https://www.pngarts.com/files/1/Jacket-Transparent-Images.png",
  },
  {
    id: 7,
    img: "https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
  },
  {
    id: 8,
    img: "https://www.pngarts.com/files/2/Swag-Cap-Transparent-Image.png",
  },
  {
    id: 9,
    img: "https://www.pngarts.com/files/3/Blazer-For-Men-PNG-Pic.png",
  },
];
